import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const AudioIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-audio"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill="#0050b3"
          className={styles.interactiveColor}
          d="M22.707 24.293C20.524 22.458 19 19.91 19 17s1.524-5.457 3.707-7.293c.986-.83-.435-2.238-1.414-1.414C18.72 10.457 17 13.593 17 17s1.72 6.543 4.293 8.707c.98.824 2.401-.584 1.414-1.414"
        />
        <path
          fill="#0050b3"
          className={styles.interactiveColor}
          d="M24.707 20.293c-.585-.494-.98-.947-1.319-1.62A3.85 3.85 0 0 1 23 17a5 5 0 0 1 .02-.456l.017-.103q.024-.128.052-.255c.08-.34.168-.592.274-.81.341-.696.745-1.163 1.344-1.67.413-.347.36-1.054 0-1.413-.409-.41-1-.35-1.414 0C21.911 13.46 21 15.17 21 17s.911 3.54 2.293 4.707c.412.348 1.01.405 1.414 0 .357-.357.415-1.064 0-1.414"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M39.727 1c4.567 0 7.679 1.493 9.515 4.005 1.052 1.438 1.493 2.876 1.59 3.937l.009.125.04.265.037.319c.268 2.547-.027 5.45-1.333 8.231-.964 2.053-2.417 3.835-4.442 5.274l-.107.076-.164.127-.1.081c-.3.25-.603.54-.883.866-.71.824-1.146 1.71-1.21 2.625l-.007.23c0 3.892-2.608 5.839-5.863 5.839-4.018 0-5.864-3.147-5.864-10.677a1 1 0 0 1 2 0l.001.36.01.694.02.658.015.316.036.606.022.29.051.556C33.506 29.664 34.716 31 36.81 31c2.188 0 3.765-1.128 3.859-3.603l.004-.236c0-1.543.647-2.936 1.701-4.16.615-.714 1.23-1.223 1.638-1.493 1.71-1.216 2.943-2.728 3.764-4.476 1.128-2.401 1.387-4.957 1.154-7.172l-.043-.352-.021-.133-.016-.13-.014-.147-.032-.204-.054-.255a6.702 6.702 0 0 0-1.121-2.453C46.178 4.203 43.67 3 39.727 3c-3.815 0-6.214 1.909-7.589 5.193-.495 1.183-.817 2.462-.996 3.744q-.07.506-.105.95l-.027.409-.01.265v.052a1 1 0 0 1-2 0l.005-.276.017-.338.013-.19.038-.422.055-.473q.016-.124.034-.254c.2-1.44.563-2.883 1.131-4.24C31.958 3.446 35.031 1 39.727 1"
        />
        <path
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
          d="M34.269 8.542c1.075-2.065 3.111-3.238 6.148-3.015 2.85.21 4.674 1.302 5.543 3.02a5.1 5.1 0 0 1 .471 3.158 1 1 0 0 1-1.977-.278l.028-.202a3.2 3.2 0 0 0-.306-1.774c-.535-1.058-1.722-1.769-3.906-1.93-2.228-.163-3.516.579-4.228 1.945a5 5 0 0 0-.474 1.433l-.04.265q-.009.06-.013.112l-.014.173-.001.06v.046l.013.147q.01.09.03.209c.056.333.156.665.307.965.38.758 1.01 1.207 2.08 1.26l.22.005c1.162 0 2.009.503 2.475 1.323.238.42.337.826.36 1.165l.006.314v2.84c-.011 1.26-.706 2.095-1.854 2.456a5 5 0 0 1-.81.18l-.306.034-.342.023-.389.015-.448.007-.517.002a1 1 0 0 1 0-2l.664-.006.378-.011.33-.018.284-.026c.745-.083.98-.264 1.007-.61l.006-1.278-.003-1.767a.8.8 0 0 0-.106-.332c-.1-.178-.259-.285-.598-.307l-.136-.004c-1.99 0-3.354-.905-4.089-2.367a5.2 5.2 0 0 1-.562-2.269c.002-.771.193-1.857.769-2.963"
        />
      </g>
    </Icon>
  )
}
